import { QueriesSearchParams } from '../../../utils/lpr.utils';
import {
  PlateResultSort,
  RecordType,
  VehicleBodyTypes,
  VehicleColorTypes,
  VehicleMakeTypes,
} from '../../constants/parameters';
import { LPRSharingDataScope } from './lpr-sharing-data-scope';

/**
 * Generic parameters to be used across providers
 */
export interface IFsLprParameters {
  includeFacets?: boolean; // Only for Axon VI and Fleet
  searchReason: string;
  plate: string;
  inBbox: QueriesSearchParams;
  fromDate: Date;
  toDate: Date;
  recordType: RecordType;
  plateState: string;
  vehicleColor: VehicleColorTypes[];
  vehicleMake: VehicleMakeTypes;
  vehicleBody: VehicleBodyTypes;
  vehicleName: string;
  assignedUserIds?: string[];
  deviceNames?: string[];
  sort: PlateResultSort;
  limit: number;
  pageSize?: number;
  includeSharedData?: boolean;
  // Geo search parameters - alternative to bbox
  point?: string; // Format: "longitude,latitude"
  radius?: number; // Radius in meters
  caseNumber?: string;
  topRack?: boolean;
  windowStickers?: boolean;
  bumperStickers?: boolean;
  // SDM properties (optional for backward compatibility)
  cameraVendors?: string; // comma separated camera vendors (for SDM)
  cameraModels?: string; // comma separated camera models (for SDM)
}
